import { fetchFactory } from 'isotope-client'
import { TaskWithDetailsApi } from './task.types'

/**
 * Get task detail for detail panel
 * @param id
 */
export const getTaskDetail = (id: string) => fetchFactory<TaskWithDetailsApi>(`/taches/detailTache/${id}`)